import { render, staticRenderFns } from "./queryModelTab.vue?vue&type=template&id=ca6e4842&scoped=true"
import script from "./queryModelTab.vue?vue&type=script&lang=js"
export * from "./queryModelTab.vue?vue&type=script&lang=js"
import style0 from "./queryModelTab.vue?vue&type=style&index=0&id=ca6e4842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6e4842",
  null
  
)

export default component.exports